import { type Model, type User } from '@kfiroo/backgammon-core'
import { type DocumentReference } from 'firebase/firestore'

import { CreatedGameApi } from '../GameApi/CreatedGameApi'
import { GameOverGameApi } from '../GameApi/GameOverGameApi'
import {
  getInProgressGameApi,
  type InProgressGameApi,
} from '../GameApi/InProgressGameApi'

export type ResolvedGame =
  | { kind: 'created'; api: CreatedGameApi }
  | { kind: 'game-over'; api: GameOverGameApi }
  | { kind: 'in-progress'; api: InProgressGameApi; playable: boolean }
  | { kind: 'unknown' }

export function resolveGameApi(
  ref: DocumentReference,
  model: Model | undefined,
  user: User,
): ResolvedGame {
  switch (model?.gameState.state) {
    case 'created':
      return { kind: 'created', api: new CreatedGameApi(ref, model, user) }
    case 'game-over':
      return { kind: 'game-over', api: new GameOverGameApi(ref, model, user) }
    case 'in-progress': {
      const api = getInProgressGameApi(ref, model, user)
      return { kind: 'in-progress', api, playable: api.playable }
    }
    default:
      return { kind: 'unknown' }
  }
}
